import "./Contact.scss";
import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import InsInput from "../../../components/InsInput/InsInput";
import { connect } from "react-redux";
import InsButton from "../../../components/InsButton/InsButton";
import InsSelect from "../../../components/InsSelect/InsSelect";
import images from "../../../ressources/images";
import { sendContactMail } from "../../../api/contact";
import { Link } from "react-router-dom";
import Validate from "../../../ressources/validation";
 
export class Contact extends Component {
  constructor(props) {
    super(props);
 
    this.state = {
      errorMsg: {},
      contact: {
        firstname: "",
        name: "",
        store: "",
        mail: "",
        object: "",
      },
      error: true,
    };
 
    this.error = true;
 
    const { t } = props;
 
    this.subject = [
      { value: "commande", label: t("order") },
      { value: "post sur le wall", label: t("contact_post_wall") },
      { value: "formation", label: t("courses") },
      { value: "autre", label: t("other") },
    ];
  }
 
  componentDidMount() {
    this.getAccount();
  }

  componentDidUpdate(prevProps) {
    const { contact } = this.state;
    if (this.props.location.pathname === "/contact" && this.props.location !== prevProps.location) {
      this.setState({ send: false, contact: { ...contact, object: "" } }, () => {
        this.checkError();
      });
    }
  }
 
  /**
   * Récupere les informations du compte
   */
  getAccount = () => {
    const { account } = this.props;
    this.setState(
      {
        contact: {
          name: account.lastname,
          firstname: account.firstname,
          store: account.store[0]?.name,
          type: this.props.t("commande"),
          mail: account.email,
          object: "",
          send: false,
        },
      },
      () => {
        this.checkError();
      }
    );
  };

  validateInputChange = (params, value) => {
    switch (params) {
      case "mail":
        return Validate("email", value) || "";
      case "firstname":
        return Validate("firstname", value) || "";
      case "name":
        return Validate("lastname", value) || "";
      default:
        return value.trim() ? "" : this.props.t("contact_fill_info");
    }
  };

  handleChange = (params) => (event) => {
    const value = event.target.value;  
    const errorMsg = this.validateInputChange(params, value?.trim());
    this.setState(
      (prevState) => ({
        contact: {
          ...prevState.contact,
          [params]: value,
        },
        errorMsg: {
          ...prevState.errorMsg,
          [params]: errorMsg,
        },
      }),
      () => {
        this.checkError();
      }
    );
  };
 
  // SET THE CATEGORY
  handleSelectSubject = (input) => (e) => {
    const value = e.target.value;
 
    this.setState((prevState) => ({
      contact: {
        ...prevState.contact,
        type: value,
      },
    }));
  };
 
  checkError = () => {
    let { contact, errorMsg } = this.state;
    const requiredFields = ["firstname", "name", "store", "mail", "object"];
    const allFieldsValid = requiredFields.every((field) => !errorMsg[field] && contact[field]?.trim());

    this.setState({ error: !allFieldsValid });
  };

  trimObjectValues = (obj) => {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = typeof obj[key] === 'string' ? obj[key].trim() : obj[key];
      return acc;
    }, {});
  };
 
  sendMail = (e) => {
    let { contact } = this.state;
    e.preventDefault();
    let trimmedContactDetails = this.trimObjectValues(contact);
    sendContactMail(trimmedContactDetails).then(() => {
      this.setState({ send: true });
    });
  };
 
  render() {
    const { history, t } = this.props;
    const { error, errorMsg, send, contact } = this.state;
    const grprLink = this.props.config.register.opt_ins.ppFilePath || "/";
 
    return (
      <div className="contact_page">
        {!send && (
          <>
            <div className="header_contact">
              <div
                className="back_link"
                onClick={(e) => history.goBack()}
              ></div>
              <div className="title">{t("contact")}</div>
              <div className="img_contact">
                <img src={images.contact} alt="" />
              </div>
            </div>
 
            <form
              className="contact_form default-layout--min-height"
              onSubmit={this.sendMail}
              style={{ overflow: "auto" }}
            >
              <InsInput
                name="firstname"
                type="text"
                placeholder={t("firstname")}
                onChange={this.handleChange("firstname")}
                error={errorMsg.firstname}
                value={contact.firstname}
              />
 
              <InsInput
                name="name"
                type="text"
                placeholder={t("lastname")}
                onChange={this.handleChange("name")}
                error={errorMsg.name}
                value={contact.name}
              />
 
              <InsInput
                name="store"
                type="text"
                placeholder={t("shop_name")}
                onChange={this.handleChange("store")}
                error={errorMsg.store}
                value={contact.store|| ""}
              />
 
              <InsInput
                name="email"
                type="text"
                placeholder={t("email")}
                onChange={this.handleChange("mail")}
                error={errorMsg.mail}
                value={contact.mail}
              />
              {/* <div className="notice">{t("answer_email")}</div> */}
 
              <InsSelect
                className="subject_select"
                name="subject"
                onChange={this.handleSelectSubject()}
                values={this.subject}
              />
 
              <div className="ins_input mb20">
                <textarea
                  className="contact_msg mb20"
                  rows="6"
                  placeholder={t("contact_placeholder")}
                  onFocus={(e) => (e.target.placeholder = "")}
                  onChange={this.handleChange("object")}
                  onBlur={(e) => {
                    this.handleChange("object");
                    e.target.placeholder = t("contact_placeholder");
                  }}
                />
                {errorMsg.object && (
                  <div className="error-msg">{errorMsg.object}</div>
                )}
              </div>
 
              {/* <p className="informations">{t("contact_informations")}</p> */}
 
              <p className="informations">
                <Trans i18nKey="contact_informations">
                  Información básica sobre Protección de Datos
                  <br />
                  <strong>Responsable</strong> L’Oréal España S.A.U.
                  <br />
                  <strong>Finalidad</strong>: La finalidad principal de
                  tratamiento de sus datos personales es prestarle el servicio
                  de atención al consumidor a través de la sección de Contacto
                  de la web.
                  <br />
                  <strong>Derechos</strong>: Acceder, rectificar y suprimir los
                  datos, así como otros derechos, como se explica en la
                  información adicional.
                  <br />
                  <strong>Información adicional</strong>: Puede consultar la
                  información adicional y detallada sobre Protección de Datos en
                  nuestra <a href={grprLink}>Política de Privacidad</a>, en
                  relación al tratamiento de datos de carácter personal para la
                  finalidad de servicio de atención al consumidor que se recoge
                  en dicha Política.
                </Trans>
              </p>
 
              <InsButton text={t("send")} type="default" disabled={error} />
 
              <input
                className="reset"
                type="reset"
                value={t("cancel")}
                onClick={() => this.props.history.goBack()}
              />
            </form>
          </>
        )}
 
        {send && (
          <div className="send_confirm">
            <div className="img_contact">
              <img src={images.contact} alt="" />
            </div>
            <div className="msg">{t("email_send")}</div>
            <Link
              to={{ pathname: "/", state: { transitionName: "slide_out" } }}
            >
              <InsButton text={t("return_home")} type="default" />
            </Link>
          </div>
        )}
      </div>
    );
  }
}
 
//extract data from the redux store
const mapStateToProps = (state) => ({
  account: state.account,
  config: state.config,
});
 
export default connect(mapStateToProps)(withTranslation()(Contact)); 
